'use client';
import { jsx } from 'react/jsx-runtime';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)t = i[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)t = i[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
let n = renderWithRef('ThumbnailsHeroThumbnailsSlidesContainer', null, (r, o)=>{
    var { children: n } = r;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: [
            'swan-thumbnails-hero-thumbnails-slides'
        ],
        props: _object_without_properties(r, [
            "children"
        ]),
        children: n
    });
});
const ThumbnailsHeroThumbnailsSlidesContainer = deprecatedComponent({
    description: 'Use AdaptiveCarousel instead',
    displayName: 'ThumbnailsHeroThumbnailsSlidesContainer',
    root: n
});

export { ThumbnailsHeroThumbnailsSlidesContainer };
